import { useEffect, useState } from "react";
import { api } from "../../api";
import { ErrorBanner, inputClass, Panel, PrimaryButton, formatTime } from "./ui";

export default function AdminAudit() {
  const [entries, setEntries] = useState<any[]>([]);
  const [townId, setTownId] = useState("");
  const [actorId, setActorId] = useState("");
  const [error, setError] = useState("");

  const load = async () => {
    setError("");
    try {
      const params = new URLSearchParams();
      if (townId) params.set("townId", townId);
      if (actorId) params.set("actorId", actorId);
      const result = await api.adminAudit(params.toString());
      setEntries(result.entries);
    } catch (e: any) {
      setError(e.message);
    }
  };
  useEffect(() => { void load(); }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-black">审计日志</h1>
        <p className="mt-1 text-sm text-[#77705f]">按操作人和小镇追踪敏感管理操作。</p>
      </div>
      <ErrorBanner message={error} />
      <Panel title="筛选">
        <div className="grid gap-3 md:grid-cols-[1fr_1fr_auto]">
          <input className={inputClass} value={townId} onChange={(e) => setTownId(e.target.value)} placeholder="小镇 ID" />
          <input className={inputClass} value={actorId} onChange={(e) => setActorId(e.target.value)} placeholder="操作人 ID" />
          <PrimaryButton onClick={load}>查询</PrimaryButton>
        </div>
      </Panel>
      <Panel title={`最近记录（${entries.length}）`}>
        <div className="space-y-2">
          {entries.map((entry) => (
            <div key={entry.id} className="grid gap-2 rounded-lg bg-[#f7f5ed] px-3 py-3 text-sm md:grid-cols-[180px_1fr_160px]">
              <div>
                <div className="font-bold">{entry.action}</div>
                <div className="text-xs text-[#8b8471]">{formatTime(entry.createdAt)}</div>
              </div>
              <div className="min-w-0">
                <div>{entry.actorUsername || entry.actorUserId}（{entry.actorRole}）</div>
                <div className="truncate text-xs text-[#77705f]">
                  town: {entry.townId || "-"} / target: {entry.targetUsername || entry.targetUserId || "-"}
                </div>
                <details className="mt-1">
                  <summary className="cursor-pointer text-xs text-[#2f6e5b]">查看变更详情</summary>
                  <pre className="mt-2 max-h-48 overflow-auto whitespace-pre-wrap rounded bg-white p-2 text-xs">
                    {JSON.stringify(entry.detail, null, 2)}
                  </pre>
                </details>
              </div>
              <div className="text-xs text-[#8b8471]">#{entry.id}</div>
            </div>
          ))}
          {!entries.length && <p className="py-8 text-center text-sm text-[#918a78]">暂无审计记录。</p>}
        </div>
      </Panel>
    </div>
  );
}
